<template>
  <div
    id="dev-FullScreenMap"
    class="full-screen-map"
  >
    <MapNavigation
      v-if="dataLoaded"
      ref="mapNavigationRef"
      :mode="mapMode"
      :has-rented-battery="hasRentedBattery"
      :last-transaction="lastTransaction"
      :campaign="campaignProp"
      :show-close-button="true"
      :start-map-only="true"
      :hide-manual-input="true"
      :user="userProp"
      @close="handleClose"
      @withdraw-battery="handleWithdrawBattery"
      @check-prices="handleCheckPrices"
    />
  </div>
</template>

<script>
  import MapNavigation from '@/components/MapNavigation.vue'
  import API from '@/services/api'
  import { TAKE_BATTERY_SUCCESS, RETURN_SUCCESS_LIST } from '@/constants.js'

  export default {
    name: 'FullScreenMap',
    components: { MapNavigation },
    data() {
      return {
        hasRentedBattery: false,
        lastTransaction: null,
        user: null,
        campaign: null,
        dataLoaded: false
      }
    },
    computed: {
      mapMode() {
        return this.hasRentedBattery ? 'return' : 'withdrawal'
      },
      userProp() {
        return this.user || {}
      },
      campaignProp() {
        return this.campaign || {}
      }
    },
    async mounted() {
      await this.fetchData()
    },
    methods: {
      async fetchData() {
        try {
          const token = localStorage.getItem('token')
          this.campaign = sessionStorage.getItem('campaign')

          if (token) {
            const [transactionResult, userResult] = await Promise.allSettled([
              API.get('/transaction/last_rent'),
              API.get('/customer/me')
            ])

            if (transactionResult.status === 'fulfilled') {
              const data = transactionResult.value.data
              // A API pode retornar a transação diretamente ou dentro de um objeto (comum em listagens ou metadados)
              const lastTransaction = data.last_transaction || (data.results && data.results[0]) || data
              this.lastTransaction = lastTransaction

              // Lógica robusta: se tem tempo de retirada mas não tem tempo de devolução, o aluguel está ativo
              // return_time === 0 é o padrão do sistema para transações pendentes
              const hasTaken = lastTransaction && lastTransaction.take_time > 0
              const notReturned = lastTransaction && (lastTransaction.return_time === 0 || !lastTransaction.return_time)

              this.hasRentedBattery = hasTaken && notReturned && !RETURN_SUCCESS_LIST.includes(lastTransaction.status)

              // Fallback para o status de sucesso caso os tempos não estejam preenchidos corretamente
              if (!this.hasRentedBattery && lastTransaction?.status === TAKE_BATTERY_SUCCESS) {
                this.hasRentedBattery = true
              }

              console.log('[FullScreenMap] Rental status check:', {
                hasRented: this.hasRentedBattery,
                status: lastTransaction?.status,
                take_time: lastTransaction?.take_time,
                return_time: lastTransaction?.return_time
              })
            }

            if (userResult.status === 'fulfilled') {
              this.user = userResult.value.data
            }
          }
        } catch (error) {
          console.error('Error fetching data for full screen map:', error)
          this.hasRentedBattery = false
        } finally {
          this.dataLoaded = true
        }
      },
      handleClose() {
        this.$router.push('/home')
      },
      handleWithdrawBattery(data) {
        // Navigate to home with the selected terminal
        this.$router.push({
          name: 'home_page',
          query: {
            token: data.token,
            point_id: data.pointId
          }
        })
      },
      handleCheckPrices(data) {
        // Navigate to home to show price table
        this.$router.push({
          name: 'home_page',
          query: {
            showPrices: 'true',
            point_id: data.pointId
          }
        })
      }
    }
  }
</script>

<style scoped>
  .full-screen-map {
    width: 100vw;
    height: var(--app-viewport-safe-height, 100vh);
    height: var(--app-viewport-safe-height, 100dvh);
    position: fixed;
    top: var(--app-fixed-top-offset, 0px);
    left: 0;
    z-index: 9999;
  }

  .full-screen-map :deep(.map-navigation-container) {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;

    /* Reset offsets for all dialogs inside the map */
    --app-fixed-top-offset: 0px;
    --app-fixed-bottom-offset: 0px;
    --app-banner-bottom-height: 0px;
  }

  .full-screen-map :deep(#dev-MapNavigation.select-card) {
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }
</style>
